<mat-nav-list>
  <a  *ngIf="!isAuth" mat-list-item routerLink="/signup" (click)="onClose()">
      <mat-icon>face</mat-icon>
      <span class="nav-caption">Signup</span>
  </a>
  <a  *ngIf="!isAuth" mat-list-item routerLink="/login" (click)="onClose()">
      <mat-icon>login</mat-icon>
      <span class="nav-caption">Login</span>
  </a>
  <a *ngIf="isAuth" mat-list-item routerLink="/training" (click)="onClose()">
      <mat-icon>fitness_center</mat-icon>
      <span class="nav-caption">Training</span>
  </a>
  <mat-list-item *ngIf="isAuth">
      <button mat-icon-button (click)="onLogout()">
          <mat-icon>eject</mat-icon>
          <span class="nav-caption">Logout</span>
      </button>
  </mat-list-item>

</mat-nav-list>